"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIAbortController = void 0;
const axios_1 = __importDefault(require("axios"));
class APIAbortController {
    constructor(abortError) {
        this.abortError = abortError;
        this.axiosCancelTokenSource = axios_1.default.CancelToken.source();
        this.tokenInUse = false;
        this.aborted = false;
        this.abortThrown = false;
    }
    static THROW_IF_ABORTED(controller) {
        if (controller) {
            controller.throwIfAborted();
        }
    }
    static IS_ABORTED(controller) {
        return (controller !== undefined && controller.getAborted());
    }
    throwIfAborted() {
        if (this.aborted && !this.abortThrown) {
            this.abortThrown = true;
            throw (this.abortError);
        }
    }
    getAborted() {
        return this.aborted;
    }
    reset() {
        this.renewCancelToken();
        this.aborted = this.abortThrown = this.tokenInUse = false;
    }
    release() {
        if (!this.aborted) {
            this.renewCancelToken();
            this.tokenInUse = false;
            return true;
        }
        else
            return false;
    }
    renewCancelToken() {
        if (this.tokenInUse) {
            this.axiosCancelTokenSource = axios_1.default.CancelToken.source();
        }
        else
            this.tokenInUse = true;
        return this.axiosCancelTokenSource.token;
    }
    abort() {
        if (!this.aborted) {
            this.aborted = true;
            this.axiosCancelTokenSource.cancel(this.abortError.message);
            this.renewCancelToken();
            this.tokenInUse = false;
            return true;
        }
        else {
            return false;
        }
    }
}
exports.APIAbortController = APIAbortController;
